import { CONSTANTS, palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  tableContainer: {
    width: '100%'
  },
  cellContent: {
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px'
  },
  cellLeft: {
    width: '100%'
  },
  rightAlign: {
    width: '100%',
    textAlign: 'right'
  },
  searchBar: {
    padding: '20px 24px',
    boxShadow: palette.shadows.light,
    background: palette.gradients.white,
    display: 'flex',
    marginTop: '32px',
    marginBottom: '32px',
    borderRadius: '2px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  searchField: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0',
      marginBottom: '20px'
    }
  },
  filterSelector: {
    width: '240px',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: 'initial',
      flex: '1 1 0'
    }
  },
  datePicker: {
    marginLeft: '10px',
    width: '200px'
  },
  cellXl: {
    width: '300px'
  },
  pageContainer: {
    paddingBottom: "".concat(CONSTANTS.PAGE_BOTTOM_PADDING, "px")
  },
  dotsOverflow: {
    textAlign: 'left',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});
export default useStyles;